// extracted by mini-css-extract-plugin
export default {"qrCodeModal":"Qrscan_qrCodeModal__yUa8U","qrVideo":"Qrscan_qrVideo__GIa9g","qrResult":"Qrscan_qrResult__cQjWR"};